export default __webpack_public_path__ + "static/media/icon_close.706dd621.svg";